module.exports = __webpack_public_path__ + "static/media/passo23.5c805b6b.jpg";